export const en = {
  // Navigation
  nav: {
    home: 'Home',
    europeanMarkets: 'European Markets',
    aboutUs: 'About Us',
    products: 'Products',
    oemSolutions: 'OEM Solutions',
    blog: 'Blog',
    clientHub: 'Client Hub',
    agentLogin: 'Agent Login',
    contact: 'Contact',
    getStarted: 'Get Started',
    smartToilets: 'Smart Toilets',
    businessSolutions: 'Business Solutions',
    technology: 'Technology',
    about: 'About',
    viewAllProducts: 'View All Products',
    flagship: 'Flagship',
    productDescriptions: {
      rem7: 'Our Premier Smart Toilet',
      luxa: 'Ultimate Luxury Line',
      luna: 'Compact Minimalist',
      nova: 'Family Smart Toilet',
      aria: 'Eco-Luxury Design',
      vena: 'Premium Bidet',
      aurelius: 'Classic Elegance',
      aurelux: 'Gold-Accented Edition',
      luma: 'Smart Innovation',
    },
  },
  
  // Common
  common: {
    learnMore: 'Learn More',
    viewDetails: 'View Details',
    requestQuote: 'Request Quote',
    downloadCatalog: 'Download Catalog',
    contactUs: 'Contact Us',
    readMore: 'Read More',
    seeAll: 'See All',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    send: 'Send',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
  },
  
  // Homepage
  home: {
    heroTitle: 'Premium Smart Toilets for European Markets',
    heroSubtitle: 'Experience the future of bathroom luxury with intelligent design and cutting-edge technology',
    exploreCollection: 'Explore Collection',
    watchVideo: 'Watch Video',
    featuredProducts: 'Featured Products',
    whyChooseUs: 'Why Choose Aureum VII Trading',
    testimonials: 'What Our Clients Say',
    certifications: 'Certifications & Standards',
  },
  
  // Products
  products: {
    title: 'Our Smart Toilet Collection',
    subtitle: 'Discover our range of premium intelligent bathroom solutions',
    features: 'Features',
    specifications: 'Technical Specifications',
    installation: 'Installation Guide',
    warranty: 'Warranty Information',
    dimensions: 'Dimensions',
    waterUsage: 'Water Usage',
    powerConsumption: 'Power Consumption',
    weight: 'Weight',
    material: 'Material',
    certification: 'Certification',
    relatedProducts: 'Related Products',
  },
  
  // Contact
  contact: {
    title: 'Get in Touch',
    subtitle: 'We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    company: 'Company Name',
    message: 'Your Message',
    sendMessage: 'Send Message',
    ourLocation: 'Our Location',
    emailUs: 'Email Us',
    callUs: 'Call Us',
    businessHours: 'Business Hours',
    weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
    weekend: 'Saturday - Sunday: Closed',
  },
  
  // About
  about: {
    title: 'About Aureum VII Trading',
    subtitle: 'Your trusted partner for premium smart toilet solutions in Europe',
    ourStory: 'Our Story',
    ourMission: 'Our Mission',
    ourVision: 'Our Vision',
    ourValues: 'Our Values',
    quality: 'Quality',
    innovation: 'Innovation',
    sustainability: 'Sustainability',
    customerFocus: 'Customer Focus',
  },
  
  // Footer
  footer: {
    description: 'Premium smart toilet solutions for the European market. Experience luxury, innovation, and sustainability.',
    quickLinks: 'Quick Links',
    products: 'Products',
    support: 'Support',
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    returnPolicy: 'Return Policy',
    shippingPolicy: 'Shipping Policy',
    allRightsReserved: 'All rights reserved.',
    followUs: 'Follow Us',
  },
  
  // Forms
  forms: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    messageSent: 'Your message has been sent successfully!',
    errorSending: 'There was an error sending your message. Please try again.',
  },
  
  // FAQ
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our smart toilets',
    stillHaveQuestions: 'Still have questions?',
    contactSupport: 'Contact our support team',
  },
  
  // Blog
  blog: {
    title: 'Latest Articles',
    subtitle: 'Stay updated with the latest trends in smart bathroom technology',
    readingTime: 'min read',
    author: 'By',
    publishedOn: 'Published on',
    categories: 'Categories',
    tags: 'Tags',
    relatedArticles: 'Related Articles',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'REM7 Smart Toilet Spain | Aureum VII Trading',
    homeDescription: 'Discover the REM7 flagship smart toilet, launching in Spain. Request a private demonstration or project pricing from Aureum VII Trading in Marbella.',
    productsTitle: 'Smart Toilet Collection | Wholesale Europe',
    productsDescription: 'Browse the full REM7 smart toilet range — tankless heating, heated bidet seats and UV sterilization. CE certified, MOQ-ready for European projects.',
    contactTitle: 'Contact & Trade Enquiries | Aureum VII',
    contactDescription: 'Speak to Aureum VII Trading in Marbella about smart toilet and bathroom fixture supply — trade pricing, MOQ, OEM and EU delivery enquiries.',
    aboutTitle: 'About Aureum VII Trading | EU Bath Supplier',
    aboutDescription: 'Aureum VII Trading supplies luxury smart toilets and bathroom fixtures from Marbella, Spain to developers, hotels and architects across Europe.',
    defaultTitle: 'Aureum VII Trading | REM7 Smart Toilets Europe',
    defaultDescription: 'Premium smart toilets and bathroom fixtures with heated seats, bidet functions and smart controls — supplied across Europe by Aureum VII Trading.',
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 Luxury Smart Toilet | Wellness Spa Technology',
      description: 'Discover the LUNA M9 smart toilet with instant heating, digital display, therapeutic spa-like bidet cleansing, and wellness features.',
      heroTitle: 'LUNA',
      heroSubtitle: 'Model M9',
      heroDescription: 'The LUNA M9 luxury smart toilet blends timeless elegance with advanced wellness-focused functionality.',
      features: {
        heatedSeat: 'Heated seat with night light',
        washModes: 'Multiple wash modes',
        dryingFunction: 'Smart drying function',
        modernDesign: 'Slim modern design',
      },
      cta: {
        downloadSpec: 'Download Specifications',
        backToCollections: '← Back to Collections',
        requestQuote: 'Request Quote',
      },
    },
    luxa: {
      title: 'LUXA M80 Flagship Smart Toilet | Premium Bidet System',
      description: 'LUXA M80 flagship smart toilet with motion sensors, tankless heating, UV sterilization, and premium automation.',
      heroTitle: 'LUXA',
      heroSubtitle: 'Model: M80',
      heroDescription: 'The LUXA M80 is the flagship of our premium collection, representing the pinnacle of intelligent bathroom innovation.',
      features: {
        motionSensor: 'Motion sensor seat lid',
        tanklessHeating: 'Tankless instant heating',
        adjustableTemp: 'Adjustable water temperature & pressure',
        premiumCeramic: 'Premium ceramic + soft-close lid',
        ecoDesign: 'Eco-friendly design',
      },
      cta: {
        downloadSpec: 'Download Specifications',
        backToCollections: '← Back to Collections',
        requestQuote: 'Request Quote',
      },
    },
    aria: {
      title: 'ARIA H60 Wall-Hung Smart Toilet | Space-Saving Design',
      description: 'ARIA H60 architectural wall-hung smart toilet with elegant design, advanced bidet technology, and space-saving installation.',
      heroTitle: 'ARIA',
      heroSubtitle: 'Model H60',
      heroDescription: 'The ARIA H60 emphasizes minimalist architectural design with maximum comfort and intelligent functionality.',
      features: {
        bidetSpray: 'Adjustable bidet spray',
        waterSaving: 'Water-saving technology',
        compactFit: 'Compact fit for small bathrooms',
        softClose: 'Soft-close lid',
      },
      cta: {
        downloadSpec: 'Download Specifications',
        backToCollections: '← Back to Collections',
        requestQuote: 'Request Quote',
      },
    },
  },
};

export type TranslationKeys = typeof en;
